require('./adhesion-units.scss');
var REFRESH_ZONES = require('src/interlock/product/ads/refresh-zones');
var adManager = require('src/interlock/product/ads/index').adManager;
var debounce = require('throttle-debounce/debounce');

var isUseUserScrollStart = false;
var isUseUserScrollEnd = false;

var isFirstScrollAfterLoadPage = true;
function userScrollHandler() {
    //skip first scroll, this may be programmatically scroll
    if (isFirstScrollAfterLoadPage) {
        isFirstScrollAfterLoadPage = false;
        return;
    }
    if (isUseUserScrollStart) {
        userScrollStarted();
    }
    else if (isUseUserScrollEnd) {
        userScrollFinished();
    }
    else {
        // anyway, if userScrollHandler was subscribed  by mistake
        $(window.document).off('scroll', userScrollHandler);
    }
}

var userScrollStarted = function() {
    userScrollFireEvent();
};

var userScrollFinished = debounce(500, function() {
    userScrollFireEvent();
});

function userScrollFireEvent() {
    $(window.document).off('scroll', userScrollHandler);
    var dataObj = {};
    dataObj.ts = (new Date()).getTime();
    adManager.refreshAdUnitsByZone(REFRESH_ZONES.USER_SCROLL,  dataObj);
}

var adhesionWrapper = $('.adhesion-wrapper');
isUseUserScrollStart = adhesionWrapper.data('user-scroll') === 'start';
isUseUserScrollEnd = adhesionWrapper.data('user-scroll') === 'end';

if (isUseUserScrollStart || isUseUserScrollEnd) {
    $(window.document).on('scroll', userScrollHandler);
}



//////////////////
// WEBPACK FOOTER
// ./src/creative/ads/adhesion-units/adhesion-units.js
// module id = 19
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14